import { Chat } from '@components'
import { useParams } from '@solidjs/router'
import { type Component, createEffect } from 'solid-js'
import { useService } from 'solid-services'
import { useChannels } from '../../../state'

export const List: Component = () => {
	const params = useParams()
	const { activeId, setActive } = useService(useChannels)()

	createEffect(() => {
		setActive(params.channelId)
	})

	return (
		<>
			<Chat
				height={{
					base: 'calc(var(--vh) * 100 - 76px)',
					lgDown: 'calc(var(--vh) * 100 - 136px)',
				}}
				currentChannelId={activeId()}
			/>
		</>
	)
}

export default List
